var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"backgroundMain"},[_c('v-app-bar',{staticClass:"topBar",attrs:{"app":"","dark":""}},[_c('div',{class:_vm.mobile ? 'd-flex align-center' : 'd-flex align-center pl-0 pt-5'}),_c('v-spacer')],1),_c('v-main',[_c('router-view',{staticClass:"mx-0 px-0"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }